import { render, staticRenderFns } from "./AddNewSageSupplierTypePopUp.vue?vue&type=template&id=85099516&scoped=true&"
import script from "./AddNewSageSupplierTypePopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewSageSupplierTypePopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSageSupplierTypePopUp.vue?vue&type=style&index=0&id=85099516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85099516",
  null
  
)

export default component.exports